import React, { Component, ReactNode } from "react";
import styled from "styled-components";
import MessageController from "../controller/MessageController";
import LogController from "../controller/LogController";

// Error Boundary 컴포넌트
interface ErrorBoundaryProps {
  children?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

let currentDate: any = null;

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error("Error caught by Error Boundary:", error);
    console.error("Error info:", errorInfo);

    console.log(currentDate);
    //로그 발송
    LogController.error({
      path: "ErrorBoundary",
      params: "error",
      params2:
        error.toString().slice(0, 100) +
        "----" +
        errorInfo.componentStack?.toString().slice(0, 300),
    });

    setTimeout(() => {
      window.ReactNativeWebView?.postMessage(
        MessageController.getActionData("refresh", undefined)
      );
    }, 1000 * 60);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <Style>
          <div className="errorWrap">
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_offline.svg`}
              alt="오프라인"
              width={"10%"}
            />
            <h1>일시적인 오류가 발생했습니다.</h1>
            <p>
              이용에 불편을 드려 죄송합니다. <br />
              잠시만 기다려주세요.
            </p>
            <p>{this.state.error?.message}</p>
            {/* <button color="white" onClick={() => window.location.reload()}>
            새로고침
          </button> */}
          </div>
        </Style>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
const Style = styled.div`
  .errorWrap {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    flex-direction: column;
    text-align: center;

    h1 {
      margin-top: 10px;
      font-size: 32px;
      font-weight: 700;
    }
    p {
      font-size: 20px;
      font-weight: 400;
      line-height: 30px;
    }
  }
`;
